import { IUser } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from '../../constants';

export const createUser = async (user: Partial<IUser>) => {
  try {
    const response = await fetch(`${API_URL}/admin/users`, {
      method: 'POST',
      body: JSON.stringify({
        ...user,
      }),
    });
    if (!response.ok) {
      throw new Error('Unknown issue, please try again later.');
    }
  } catch (e) {
    throw new Error(e.message);
  }
};
